/** English number-line prompt (ADR 0051 part 3). Unchanged from the original inline text. */
export const numberLinePrompts = {
    arrow: () => `What number is the arrow pointing to?`,
};
